// type Attribution = {
//   fbclid?: string | null
//   ttclid?: string | null
//   fbc?: string | null // para Meta (usa fbclid)

//   utm_source?: string | null
//   utm_medium?: string | null
//   utm_campaign?: string | null
//   utm_content?: string | null
//   utm_term?: string | null
// }

export const STORAGE_TRACKING = 'offstore:tracking';

export function saveStorageTracking(data) {
  if (typeof window === 'undefined') return;
  localStorage.setItem(STORAGE_TRACKING, JSON.stringify(data));
}

export function getStorageTracking() {
  const data = localStorage.getItem(STORAGE_TRACKING);
  return data ? JSON.parse(data) : null;
}

export function updateStorageTracking(data) {
  if (typeof window === 'undefined') return;
  const storage = getStorageTracking();
  localStorage.setItem(
    STORAGE_TRACKING,
    JSON.stringify({ ...storage, ...data })
  );
}

export function removeStorageTracking() {
  localStorage.removeItem(STORAGE_TRACKING);
}
